import moment from 'moment'
import NProgress from 'nprogress'
import * as lou from '@/services/data/lou'
const ExcelJS = require('exceljs')

export async function exportExcelHelper(columns, data, filename = 'ExportedData.xlsx') {
  NProgress.start()

  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'Heasoft System'
  workbook.lastModifiedBy = 'Heasoft'
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.lastPrinted = new Date()

  const alphabeth = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
  const worksheet = workbook.addWorksheet(moment().format('DD-MM-YYYY'))

  const clonedColumns = JSON.parse(JSON.stringify(columns))
  const clonedData = JSON.parse(JSON.stringify(data))

  const processedData = clonedData.map(el => ({
    ...el,
    tgl: el.tgl === null ? '' : moment(el.tgl, 'YYYY-MM-DD').format('DD-MM-YYYY'),
  }))

  let cfirst = 0
  let cloop = 0
  let dincrement = 2

  for (let i = 0; i < clonedColumns.length; i++) {
    const element = clonedColumns[i]
    if (element.title.toString() === 'Action') continue

    const cloopni = cloop - 1
    const hname = element.title.toString().replaceAll(' ', '')

    const colLetter = cloop === 0
      ? alphabeth[cfirst]
      : alphabeth[cloopni] + alphabeth[cfirst]

    worksheet.getCell(colLetter + '1').value = hname

    for (let u = 0; u < processedData.length; u++) {
      worksheet.getCell(colLetter + dincrement).value = processedData[u][element.dataIndex]
      dincrement = u + 1 === processedData.length ? 2 : dincrement + 1
    }

    if (cfirst === 25) {
      cfirst = 0
      cloop += 1
    } else {
      cfirst += 1
    }
  }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()

  NProgress.done()
}

export async function exportPDFAPI(url) {
  var res = await lou.ngetDocumentPdf(url, false, false)
  if (res) {
    // console.log("Success", response);
    const blob = new Blob([res], {
      type: 'application/pdf',
    })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.target = '_blank'
    // link.download = filename
    link.click()
    // const objectUrl = URL.createObjectURL(blob)
    // console.log('objectUrl', objectUrl)
    // this.amodal.ArrayBuffer = objectUrl
    URL.revokeObjectURL(blob)
    // setTimeout(() => {
    //   // this.componentKey += 1
    //   // this.amodalvisible = true
    // }, 500)
  }
}

export async function exportPDFLocal(columns, data, filename = 'ExportedData.pdf') {
  NProgress.start()

  try {
    // Convert data to the format needed for PDF
    const clonedColumns = JSON.parse(JSON.stringify(columns))
      .filter(col => col.title.toString() !== 'Action')
      .map(col => col.title)

    const clonedData = JSON.parse(JSON.stringify(data))

    // Format the data for PDF
    const tableData = clonedData.map(row => {
      const rowData = {}
      columns.forEach(col => {
        if (col.title.toString() !== 'Action') {
          // Handle date formatting if needed
          if (col.dataIndex === 'tgl' && row[col.dataIndex]) {
            rowData[col.title] = moment(row[col.dataIndex], 'YYYY-MM-DD').format('DD-MM-YYYY')
          } else {
            rowData[col.title] = row[col.dataIndex]
          }
        }
      })
      return rowData
    })

    // Create PDF document using browser's print functionality
    // This is a simple approach - for more advanced PDF generation,
    // you might want to use a library like jsPDF or pdfmake

    // Create a hidden iframe
    const printFrame = document.createElement('iframe')
    printFrame.style.position = 'fixed'
    printFrame.style.right = '0'
    printFrame.style.bottom = '0'
    printFrame.style.width = '0'
    printFrame.style.height = '0'
    printFrame.style.border = '0'
    document.body.appendChild(printFrame)

    // Write the HTML content to the iframe
    const printDocument = printFrame.contentWindow.document
    printDocument.write('<html><head><title>' + filename + '</title>')
    printDocument.write('<style>')
    printDocument.write('table { border-collapse: collapse; width: 100%; }')
    printDocument.write('th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }')
    printDocument.write('th { background-color: #f2f2f2; }')
    printDocument.write('</style></head><body>')
    printDocument.write('<h2>' + filename.replace('.pdf', '') + '</h2>')
    printDocument.write('<table>')

    // Add table header
    printDocument.write('<tr>')
    clonedColumns.forEach(title => {
      printDocument.write('<th>' + title + '</th>')
    })
    printDocument.write('</tr>')

    // Add table rows
    tableData.forEach(row => {
      printDocument.write('<tr>')
      clonedColumns.forEach(title => {
        printDocument.write('<td>' + (row[title] || '') + '</td>')
      })
      printDocument.write('</tr>')
    })

    printDocument.write('</table></body></html>')
    printDocument.close()

    // Print the iframe content
    printFrame.contentWindow.focus()
    printFrame.contentWindow.print()

    // Remove the iframe after printing
    setTimeout(() => {
      document.body.removeChild(printFrame)
    }, 1000)
  } catch (error) {
    console.error('Error exporting PDF:', error)
    lou.shownotif('Error', 'Failed to export PDF')
  }

  NProgress.done()
}

export async function exportPDFHelper(columns, data, filename = 'ExportedData.pdf') {
  NProgress.start()

  try {
    // Import jsPDF dynamically
    const { jsPDF } = await import('jspdf');
    const { autoTable } = await import('jspdf-autotable');

    // Create a new PDF document
    // eslint-disable-next-line new-cap
    const doc = new jsPDF();

    // Format the data for PDF
    const tableColumns = columns
      .filter(col => col.title.toString() !== 'Action')
      .map(col => col.title);

    const tableRows = data.map(row => {
      return columns
        .filter(col => col.title.toString() !== 'Action')
        .map(col => {
          // Handle date formatting if needed
          if (col.dataIndex === 'tgl' && row[col.dataIndex]) {
            return moment(row[col.dataIndex], 'YYYY-MM-DD').format('DD-MM-YYYY');
          }
          return row[col.dataIndex] || '';
        });
    });

    // Add title to the PDF
    doc.text(filename.replace('.pdf', ''), 14, 15);

    // Add the table to the PDF
    doc.autoTable({
      head: [tableColumns],
      body: tableRows,
      startY: 20,
      theme: 'grid',
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: 255,
        fontStyle: 'bold',
      },
    });

    // Save the PDF
    doc.save(filename);
  } catch (error) {
    console.error('Error exporting PDF:', error);
    lou.shownotif('Error', 'Failed to export PDF');
  }

  NProgress.done();
}

export async function exportExcelUtils(columnDefs, rowData, columnDefsTotal, rowDataTotal, whatform) {
  const ExcelJS = require('exceljs')
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'LB-BPRS Heasoft System'
  workbook.lastModifiedBy = 'Me'
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.lastPrinted = new Date()
  var alphabeth = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  const worksheet = workbook.addWorksheet(moment().format('DD-MM-YYYY'))

  // Table Data
  var column = deepClone(columnDefs)
  var data = deepClone(rowData)
  var cfirst = 0
  var cloop = 0
  var dincrement = 2
  var columnLocation = []
  for (let i = 0; i < column.length; i++) {
    const element = column[i]
    var cloopni = cloop - 1
    var hname = element.headerName.toString()
    if (cloop === 0) {
      columnLocation.push({
        location: alphabeth[cfirst],
        field: element.field,
      })
      worksheet.getCell(alphabeth[cfirst] + '1').value = hname.replaceAll(' ', '')
    } else {
      columnLocation.push({
        location: alphabeth[cloopni] + alphabeth[cfirst],
        field: element.field,
      })
      worksheet.getCell(alphabeth[cloopni] + alphabeth[cfirst] + '1').value = hname.replaceAll(' ', '')
    }
    for (let u = 0; u < data.length; u++) {
      const el = data[u]
      if (cloop === 0) {
        worksheet.getCell(alphabeth[cfirst] + dincrement).value = el[element.field]
      } else {
        worksheet.getCell(alphabeth[cloopni] + alphabeth[cfirst] + dincrement).value = el[element.field]
      }
      var checklast = u + 1
      if (checklast === data.length) {
        dincrement = 2
      } else {
        dincrement += 1
      }
    }
    if (cfirst === 25) {
      cfirst = 0
      cloop += 1
    } else {
      cfirst += 1
    }
  }
  var last = data.length + 3
  worksheet.mergeCells('A' + last + ':B' + last)
  worksheet.getCell('A' + last).value = 'Total'
  for (let ti = 0; ti < columnDefsTotal.length; ti++) {
    const element = columnDefsTotal[ti]
    var targetLoc = columnLocation.findIndex(x => x.field === element.field)
    if (targetLoc >= 0) {
      worksheet.getCell(columnLocation[targetLoc].location + last).value = rowDataTotal[0][element.field]
    }
  }
  // write to a new buffer
  const buffer = await workbook.xlsx.writeBuffer()
  var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  var form = whatform.slice(7, whatform.length)
  link.download = 'Export Excel Form KC' + form + '.xlsx'
  link.click()
}

async function exportExcelOriginalFormKC0600() {
  const ExcelJS = require('exceljs')
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'LB-BPRS Heasoft System'
  workbook.lastModifiedBy = 'Me'
  workbook.created = new Date()
  workbook.modified = new Date()
  workbook.lastPrinted = new Date()
  var alphabeth = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
  const worksheet = workbook.addWorksheet(moment().format('DD-MM-YYYY'))

  // Table Data
  var column = this.$g.clone(this.columnDefs)
  var data = this.$g.clone(this.rowAfterFilter)
  var cfirst = 0
  var cloop = 0
  var dincrement = 2
  var columnLocation = []
  for (let i = 0; i < column.length; i++) {
    const element = column[i]
    var cloopni = cloop - 1
    var hname = element.headerName.toString()
    if (cloop === 0) {
      columnLocation.push({
        location: alphabeth[cfirst],
        field: element.field,
      })
      worksheet.getCell(alphabeth[cfirst] + '1').value = hname.replaceAll(' ', '')
    } else {
      columnLocation.push({
        location: alphabeth[cloopni] + alphabeth[cfirst],
        field: element.field,
      })
      worksheet.getCell(alphabeth[cloopni] + alphabeth[cfirst] + '1').value = hname.replaceAll(' ', '')
    }
    for (let u = 0; u < data.length; u++) {
      const el = data[u]
      if (cloop === 0) {
        worksheet.getCell(alphabeth[cfirst] + dincrement).value = el[element.field]
      } else {
        worksheet.getCell(alphabeth[cloopni] + alphabeth[cfirst] + dincrement).value = el[element.field]
      }
      var checklast = u + 1
      if (checklast === data.length) {
        dincrement = 2
      } else {
        dincrement += 1
      }
    }
    if (cfirst === 25) {
      cfirst = 0
      cloop += 1
    } else {
      cfirst += 1
    }
  }
  var last = data.length + 3
  worksheet.mergeCells('A' + last + ':B' + last)
  worksheet.getCell('A' + last).value = 'Total'
  for (let ti = 0; ti < this.columnDefsTotal.length; ti++) {
    const element = this.columnDefsTotal[ti]
    var targetLoc = columnLocation.findIndex(x => x.field === element.field)
    if (targetLoc >= 0) {
      worksheet.getCell(columnLocation[targetLoc].location + last).value = this.rowDataTotal[0][element.field]
    }
  }
  // write to a new buffer
  const buffer = await workbook.xlsx.writeBuffer()
  var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  var form = this.whatform.slice(7, this.whatform.length)
  link.download = 'Export Excel Form KC' + form + '.xlsx'
  link.click()
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}
